import {
  type Conditions,
  conditionsSchema,
} from '@risksmart-app/form-configuration/src/field-types/types';

export type WithParsedConditions<T extends { Conditions?: unknown }> = Omit<
  T,
  'Conditions'
> & {
  Conditions?: Conditions | null;
};

const optionalConditionsSchema = conditionsSchema
  .extend({
    tokens: conditionsSchema.shape.tokens.default([]),
  })
  .nullish();

/** Read stored rules independently so a malformed row cannot disable the form. */
export const parseFormConfigurationConditions = <
  T extends { Conditions?: unknown },
>(
  value: T
): WithParsedConditions<T> => {
  const parsed = optionalConditionsSchema.safeParse(value.Conditions);

  return { ...value, Conditions: parsed.success ? parsed.data : undefined };
};
